import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { cycle } from '../models/cycle.model';
import { CycleTVO } from '../models/cycleTVO.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  public saveSubsject: Subject<boolean> = new Subject<boolean>();

  public isSaveButtonDisaledSubject: Subject<boolean> = new Subject<boolean>();

  public isSaving: boolean = false;

  public CycleTVOBehaviorSubject: BehaviorSubject<CycleTVO | undefined> = new BehaviorSubject<CycleTVO | undefined>(
    undefined
  );

  public CycleNurseBehaviorSubject: Subject<cycle | undefined | null> = new Subject<cycle | undefined | null>();

  public CyclesSubject: Subject<cycle[] | undefined> = new Subject<cycle[] | undefined>();

  public SelectedCycleSubject: Subject<cycle> = new Subject<cycle>();

  public isChangedMaincCycle: Subject<boolean> = new Subject<boolean>();

  public cycleLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public RefreshCycleTVOBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  public RefreshNurseCycleBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  public addRoomSubject: Subject<void> = new Subject<void>();

  public onFilterSubject: Subject<void> = new Subject<void>();

  public openPopupSubject: Subject<void> = new Subject<void>();

  public checkConflictsAndGenerateCalendarsSubject: Subject<void> = new Subject<void>();

  public checkConflictsAndGenerateNightNeedsSubject: Subject<void> = new Subject<void>();

  public updateCycleSubject: Subject<void> = new Subject<void>();

  public deleteCycleSubject: Subject<void> = new Subject<void>();

  public openProfilesSubject: Subject<void> = new Subject<void>();

  public checkConflictsAndGenerateCalendarsCycleSubject: Subject<void> = new Subject<void>();

  public deleteCyclePlanningSubject: Subject<void> = new Subject<void>();

  public toggleDayNightSubject: Subject<boolean> = new Subject<boolean>();

  public onFilterNeedsSubject: Subject<void> = new Subject<void>();

  public checkConflictsAndGenerateCalendarsNeedsSubject: Subject<void> = new Subject<void>();

  public filteredSpecialtyNumber: Subject<number> = new Subject<number>();

  public filteredSpecialtyNeedsNumberSubject: Subject<number> = new Subject<number>();

  public addSpecialtySubject: Subject<void> = new Subject<void>();

  public createCycle: Subject<void> = new Subject<void>();

  public addReasonMapSubject: Subject<void> = new Subject<void>();

  onCreateClick() {
    this.createCycle.next();
  }

  getCreatedClick() {
    return this.createCycle;
  }

  clear(): void {
    this.saveSubsject.complete();
    this.saveSubsject = new Subject<boolean>();

    this.isSaveButtonDisaledSubject.complete();
    this.isSaveButtonDisaledSubject = new Subject<boolean>();

    this.isSaving = false;

    this.CycleTVOBehaviorSubject.complete();
    this.CycleTVOBehaviorSubject = new BehaviorSubject<CycleTVO | undefined>(undefined);

    this.CycleNurseBehaviorSubject.complete();
    this.CycleNurseBehaviorSubject = new Subject<cycle | undefined | null>();

    this.CyclesSubject.complete();
    this.CyclesSubject = new Subject<cycle[] | undefined>();

    this.SelectedCycleSubject.complete();
    this.SelectedCycleSubject = new Subject<cycle>();

    this.isChangedMaincCycle.complete();
    this.isChangedMaincCycle = new Subject<boolean>();

    this.cycleLoading.complete();
    this.cycleLoading = new BehaviorSubject<boolean>(true);

    this.RefreshCycleTVOBehaviorSubject.complete();
    this.RefreshCycleTVOBehaviorSubject = new BehaviorSubject<any>(false);

    this.RefreshNurseCycleBehaviorSubject.complete();
    this.RefreshNurseCycleBehaviorSubject = new BehaviorSubject<any>(false);

    this.addRoomSubject.complete();
    this.addRoomSubject = new Subject<void>();

    this.onFilterSubject.complete();
    this.onFilterSubject = new Subject<void>();

    this.openPopupSubject.complete();
    this.openPopupSubject = new Subject<void>();

    this.checkConflictsAndGenerateCalendarsSubject.complete();
    this.checkConflictsAndGenerateCalendarsSubject = new Subject<void>();

    this.checkConflictsAndGenerateNightNeedsSubject.complete();
    this.checkConflictsAndGenerateNightNeedsSubject = new Subject<void>();

    this.updateCycleSubject.complete();
    this.updateCycleSubject = new Subject<void>();

    this.deleteCycleSubject.complete();
    this.deleteCycleSubject = new Subject<void>();

    this.openProfilesSubject.complete();
    this.openProfilesSubject = new Subject<void>();

    this.checkConflictsAndGenerateCalendarsCycleSubject.complete();
    this.checkConflictsAndGenerateCalendarsCycleSubject = new Subject<void>();

    this.deleteCyclePlanningSubject.complete();
    this.deleteCyclePlanningSubject = new Subject<void>();

    this.toggleDayNightSubject.complete();
    this.toggleDayNightSubject = new Subject<boolean>();

    this.onFilterNeedsSubject.complete();
    this.onFilterNeedsSubject = new Subject<void>();

    this.checkConflictsAndGenerateCalendarsNeedsSubject.complete();
    this.checkConflictsAndGenerateCalendarsNeedsSubject = new Subject<void>();

    this.filteredSpecialtyNumber.complete();
    this.filteredSpecialtyNumber = new Subject<number>();

    this.filteredSpecialtyNeedsNumberSubject.complete();
    this.filteredSpecialtyNeedsNumberSubject = new Subject<number>();

    this.addSpecialtySubject.complete();
    this.addSpecialtySubject = new Subject<void>();

    this.createCycle.complete();
    this.createCycle = new Subject<void>();

    this.addReasonMapSubject.complete();
    this.addReasonMapSubject = new Subject<void>();
  }
}
